import { useEffect, useState } from "react";
import nodeinstance from "../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import EditemployeePopUp from "./editemployeePopUp";
import { useLocation, useNavigate } from "react-router-dom";
import { CgSpinner } from "react-icons/cg";
import CancelPopUpInvoice from "./CancelInvoivePopUp";
import EmployeeExcel from "./ExcelTemplate";

export default function Employeeseclist({
  invoiceNumber,
  contract_id,
  quotationType,
}) {
  console.log("contract_id.........", quotationType);
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];

  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];
  const token = localStorage.getItem("nodeToken");

  const [employee, setEmployee] = useState();
  const dispatch = useDispatch();
  const [updatedAmount, setUpdatedAmount] = useState();
  const [differenceAmount, setDifferenceAmount] = useState();

  const employeeData = async () => {
    try {
      const reqObject = {
        invoice_no: invoiceNumber.invoice_no,
        invoice_type: invoiceNumber.invoice_type,
      };
      const response = await nodeinstance.post(
        `/dashboard/visaSecOnArrival/getDetailsEdit`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setEmployee(response?.data?.data);
      }
    } catch (error) {
      console.log("error to be displayed here......", error);
      dispatch(
        setAppError({
          msg: "failed to fetch employee data...",
        })
      );
    }
  };
  console.log("employee......employee", employee);
  useEffect(() => {
    employeeData();
  }, [invoiceNumber]);

  const [updatedData, setUpdatedData] = useState([]);

  const handleDataChange = (name, value, i) => {
    console.log("Data to be printed here.........", name, value, i);
    if (value < 0) {
      dispatch(
        setAppError({
          msg: "Input value should be greater then 0",
        })
      );
      return;
    }

    setUpdatedData((previousData) => {
      // Correctly update the state by mapping through the previousData
      const updated = previousData.map((item, index) => {
        if (index === i) {
          // Update the specific item at index i
          return {
            ...item,
            [name]: value,
          };
        }
        // Return the item unchanged if it's not the one we're updating
        return item;
      });

      console.log("Updated data: ", updated);
      return updated; // Return the updated array to update the state
    });
  };

  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const handleCheckboxChange = (event, candidate_id) => {
    const isChecked = event.target.checked;
    setSelectedCandidates((prevState) => {
      if (isChecked) {
        if (!prevState.includes(candidate_id)) {
          return [...prevState, candidate_id];
        }
      } else {
        return prevState.filter((id) => id !== candidate_id);
      }
      return prevState;
    });
  };
  const Contract_tenure =
    parseInt(updatedData && updatedData[0]?.Contract_tenure) * 30;
  console.log("Contract_tenure...........", Contract_tenure);

  useEffect(() => {
    if (employee && employee.length > 0) {
      const timeoutId = setTimeout(() => {
        setUpdatedData((previousData) => {
          // const updatedData = {
          const updatedData = employee?.map((item, index) => {
            const updatedItem = {
              ...item,
            };
            console.log("gyfgygygdfygydyfgyugyfdu", updatedItem);
            // Calculate total based on the updated values
            let total =
              parseFloat((updatedItem.visa_fee / 360) * Contract_tenure || 0) +
              parseFloat((updatedItem.iqama_fee / 360) * Contract_tenure || 0) +
              parseFloat(
                (updatedItem.work_permit / 360) * Contract_tenure || 0
              ) +
              parseFloat(
                (updatedItem.driving_license / 360) * Contract_tenure || 0
              ) +
              parseFloat(
                (updatedItem.labor_card / 360) * Contract_tenure || 0
              ) +
              parseFloat((updatedItem.insurance / 360) * Contract_tenure || 0) +
              parseFloat((updatedItem.baladiyah / 360) * Contract_tenure || 0) +
              parseFloat((updatedItem.ajeer / 360) * Contract_tenure || 0) +
              parseFloat(
                (updatedItem.medical_for_iqama / 360) * Contract_tenure || 0
              ) +
              parseFloat((updatedItem.muqeem / 360) * Contract_tenure || 0) +
              parseFloat(
                (updatedItem.payroll_card / 360) * Contract_tenure || 0
              ) +
              parseFloat(
                (updatedItem.end_of_service / 360) * Contract_tenure || 0
              ) +
              parseFloat(
                (updatedItem.vacation_salary / 360) * Contract_tenure || 0
              ) +
              parseFloat(
                (updatedItem.vacation_ticket / 360) * Contract_tenure || 0
              );
            console.log("total.............", total);
            return {
              ...updatedItem,
              total: total.toFixed(2), // Update total
            };
          });
          // };
          return updatedData;
        });
      }, 1000); // 1000ms delay

      return () => clearTimeout(timeoutId);
    }
  }, [employee]);
  console.log("selectedCandidates......selectedCandidates", updatedData);

  const totalInvoiceAmount = employee?.reduce((total, item) => {
    return total + Number(item.sec_deposit_cost || 0);
  }, 0);

  useEffect(() => {
    let UpdatedInvoiceAmount;
    if (invoiceNumber.invoice_type === "SEC DEPOSIT") {
      UpdatedInvoiceAmount = updatedData?.reduce((total, item) => {
        return total + Number(item.sec_deposit_cost || 0);
      }, 0);
    } else {
      UpdatedInvoiceAmount = Number(
        updatedData
          ?.reduce((total, item) => {
            const visaDepositCost = Number(item.visa_deposit_cost || 0);
            const amountWithPercentage =
              visaDepositCost + visaDepositCost * 0.15; // Add 15%
            return total + amountWithPercentage;
          }, 0)
          .toFixed(2)
      );
    }
    console.log("UpdatedInvoiceAmount............", UpdatedInvoiceAmount);
    setUpdatedAmount(UpdatedInvoiceAmount);
    let diffAmount =
      UpdatedInvoiceAmount - parseInt(employee && employee[0]?.invoice_amount);
    setDifferenceAmount(diffAmount);
  }, [updatedData]);

  console.log("totalLoanAdvance...........", updatedAmount);

  const [openPopUp, setOpenPopUp] = useState(false);

  const onSubmit = () => {
    setOpenPopUp(true);
  };

  const navigate = useNavigate();

  const deleteEmployee = async () => {
    try {
      const employee_ids = selectedCandidates.map((data) => data);

      const matches = [];

      for (let i = 0; i < updatedData.length; i++) {
        if (employee_ids.includes(updatedData[i].employee_id)) {
          matches.push({
            employee_id: updatedData[i].employee_id,
            sec_deposit_cost: updatedData[i].sec_deposit_cost,
          });
        }
      }
      const totalInvoiceAmount = matches?.reduce((total, item) => {
        return total + Number(item.sec_deposit_cost || 0);
      }, 0);

      console.log("hshshshshhshhhshshshhsh", totalInvoiceAmount);
      const reqObject = {
        employee_ids: employee_ids,
        credit_note: totalInvoiceAmount,
        quantity: employee_ids?.length,
        invoice_type: invoiceNumber.invoice_type,
        invoice_no: employee && employee[0]?.invoice_no,
        quotationType: quotationType,
      };
      console.log("employee_idssssssssssssssssss......", reqObject);
      const response = await nodeinstance.delete(
        `/dashboard/visaSecOnArrival/deleteEmployees`,
        {
          data: { reqObject },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Employee removed successfully",
            color: "success",
          })
        );
        navigate("/dashboard/visa-cost-&-sec-deposit/summary-OnArrival");
      }
    } catch (error) {
      console.log("error......", error);
      dispatch(
        setAppError({
          msg: "Failed to update data.",
        })
      );
    }
  };
  console.log(
    "employee...................employeessssssssssssssssssssssssssssssssssssssss",
    updatedData,
    invoiceNumber
  );

  const location = useLocation();

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA COST AND SECURITY DEPOSIT",
          link: "/dashboard/visa-cost-&-sec-deposit",
        },
        {
          label: "Summary",
          link: "/dashboard/visa-cost-&-sec-deposit/summary-OnArrival",
        },
        {
          label: `EditEmployee`,
        },
      ])
    );
  }, [location]);

  const [downloading, setDownloading] = useState();

  const downloadEmployeeDetails = async () => {
    setDownloading(true);
    try {
      const reqObject = {
        invoice_no: employee && employee[0]?.invoice_no,
      };
      const response = await nodeinstance.post(
        `/dashboard/visaSecOnArrival/editDetailsDownload`,
        reqObject,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Employee List`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloading(false);
      }
    } catch (error) {
      console.log("error to be capctured here...", error);
      setDownloading(true);
      dispatch(
        setAppError({
          msg: "Error while downloading employee report.",
        })
      );
    }
  };

  const [cancelPopUp, setCancelPopUp] = useState(false);

  const onCancelInvoiceClick = async () => {
    setCancelPopUp(true);
  };

  return (
    <>
      {!employee ? (
        <h1>No Data found</h1>
      ) : (
        <>
          <div className="mt-4 mx-4 flex justify-between">
            <div className="text-left">
              <h2>
                CLIENT NAME:{" "}
                <strong>
                  <span className="text-red">
                    {" "}
                    {employee && employee[0]?.client}
                  </span>
                </strong>
              </h2>
              <h2>
                EMPLOYEES COUNT:
                <strong>
                  <span className="text-red"> {employee?.length}</span>
                </strong>
              </h2>
              <h2>
                INVOICE NUMBER:
                <strong>
                  <span className="text-red">
                    {" "}
                    {employee && employee[0]?.invoice_no}
                  </span>
                </strong>
              </h2>
            </div>
            <div className="text-center flex-grow">
              <h2>
                INVOICE AMOUNT (INC. VAT):
                {/* {"XYZ"} */}
                <strong>
                  <span className="text-red">
                    {" "}
                    {employee && employee[0]?.invoice_amount}
                  </span>
                </strong>
              </h2>
              <h2>
                REVISED AMOUNT (INC. VAT):
                <strong>
                  <span className="text-red">
                    {" "}
                    {updatedAmount ? updatedAmount : 0}{" "}
                  </span>
                </strong>
              </h2>
              <h2>
                DIFFERENCE AMOUNT (INC. VAT) :
                <strong>
                  <span className="text-red">
                    {" "}
                    {differenceAmount ? differenceAmount : 0}{" "}
                  </span>
                </strong>
              </h2>
            </div>
            <div className="flex items-center justify-end">
              <input
                type="radio"
                name="creditnote"
                id="creditnote"
                checked={differenceAmount <= 0}
                className="mr-2"
              />
              <label htmlFor="creditnote" className="mr-4">
                Add credit note
              </label>
              <input
                type="radio"
                name="newinvoice"
                id="newinvoice"
                checked={differenceAmount > 0}
                className="mr-2"
              />
              <label htmlFor="newinvoice" className="mr-4">
                Generate new invoice{" "}
              </label>
              <button
                className="p-1 px-2 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 h-10 p-3"
                onClick={() =>
                  EmployeeExcel("Employee_Report", updatedData, invoiceNumber)
                }
                disabled={downloading}
              >
                <p>Download</p>
                {downloading && <CgSpinner className="animate-spin" />}
              </button>
            </div>
          </div>
          <div
            className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-2 "
            style={rowsData?.data?.length > 4 ? { height: "250px" } : {}}
          >
            <div className="flex">
              {row.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  {sectionIndex == 0 && (
                    <>
                      <div className={`flex w-full gap-1 `}>
                        <>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            S.NO.
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            SELECT
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            EMP ID
                          </h3>

                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            EMP NAME
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            CLIENT
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            VISA PROVIDER
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            NATIONALITY
                          </h3>

                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            PASSPORT NUMBER
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            ACTUAL PROFESSION
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            VISA PROFESSION
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            {invoiceNumber.invoice_type === "SEC DEPOSIT"
                              ? "SECURITY DEPOSIT COST"
                              : "VISA DEPOSIT COST"}
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            VISA FEE
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            IQAMA FEE
                          </h3>

                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            WORK PERMIT
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            DRIVING LICENSE
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            LABOR CARD
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            INSURANCE
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            BALADIYAH
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            AJEER
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            MEDICAL FOR IQAMA
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            MUQEEM
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            PAYROLL CARD
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            END OF SERVICE
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            VACATION SALARY
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            VACATION TICKET
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            TOTAL AMOUNT
                          </h3>
                        </>
                      </div>
                    </>
                  )}
                  <div className="mb-2">
                    {updatedData?.map((candidate, index) => (
                      <div
                        className="flex w-full gap-1 relative mb-2 mt-2"
                        key={index}
                      >
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {index + 1}
                        </p>

                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <input
                            key={candidate.employee_id}
                            type="checkbox"
                            checked={selectedCandidates.includes(
                              candidate.employee_id
                            )}
                            onChange={(event) =>
                              handleCheckboxChange(event, candidate.employee_id)
                            }
                            disabled={
                              updatedData &&
                              updatedData[0]?.amount_received != null
                            }
                          />
                        </p>

                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.employee_id}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.name}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.client}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.visa_provider
                            ? candidate.visa_provider
                            : "N/A"}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.nationality}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.passport_number}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.job_position
                            ? candidate.job_position
                            : "N/A"}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {candidate.visa_profession}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              invoiceNumber.invoice_type === "SEC DEPOSIT"
                                ? candidate.sec_deposit_cost
                                : candidate.visa_deposit_cost
                            }
                            name="sec_deposit_cost"
                            onChange={(event) => {
                              handleDataChange(
                                event.target.name,
                                event.target.value,
                                index
                              );
                            }}
                            min="1"
                            disabled={
                              (updatedData &&
                                updatedData[0]?.amount_received != null) ||
                              invoiceNumber.invoice_type != "SEC DEPOSIT"
                            }
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {(candidate.visa_fee / 360) * Contract_tenure}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {(candidate.iqama_fee / 360) * Contract_tenure}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {(candidate.work_permit / 360) * Contract_tenure}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {(candidate.driving_license / 360) * Contract_tenure}
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {(candidate.labor_card / 360) * Contract_tenure}
                        </p>

                        <input
                          // type="number"
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                          value={(candidate.insurance / 360) * Contract_tenure}
                          disabled
                        />
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              (candidate.baladiyah / 360) * Contract_tenure
                            }
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={(candidate.ajeer / 360) * Contract_tenure}
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              (candidate.medical_for_iqama / 360) *
                              Contract_tenure
                            }
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {candidate.labor_card} */}
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={(candidate.muqeem / 360) * Contract_tenure}
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {candidate.insurance} */}
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              (candidate.payroll_card / 360) * Contract_tenure
                            }
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {candidate.Baladiyah} */}
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              (candidate.end_of_service / 360) * Contract_tenure
                            }
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {candidate.Ajeer} */}
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              (candidate.vacation_salary / 360) *
                              Contract_tenure
                            }
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {candidate.Medical_for_iqama} */}
                          <input
                            type="number"
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight} text-center`}
                            value={
                              (candidate.vacation_ticket / 360) *
                              Contract_tenure
                            }
                            disabled
                          />
                        </p>
                        <p
                          className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                        >
                          {/* {candidate.total} */}
                          {parseFloat(
                            (candidate.visa_fee / 360) * Contract_tenure || 0
                          ) +
                            parseFloat(
                              (candidate.iqama_fee / 360) * Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.work_permit / 360) * Contract_tenure ||
                                0
                            ) +
                            parseFloat(
                              (candidate.driving_license / 360) *
                                Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.labor_card / 360) * Contract_tenure ||
                                0
                            ) +
                            parseFloat(
                              (candidate.insurance / 360) * Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.baladiyah / 360) * Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.ajeer / 360) * Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.medical_for_iqama / 360) *
                                Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.muqeem / 360) * Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.payroll_card / 360) *
                                Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.end_of_service / 360) *
                                Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.vacation_salary / 360) *
                                Contract_tenure || 0
                            ) +
                            parseFloat(
                              (candidate.vacation_ticket / 360) *
                                Contract_tenure || 0
                            )}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            {openPopUp ? (
              <EditemployeePopUp
                showPromptElement={openPopUp}
                setPrompotElement={setOpenPopUp}
                amount={differenceAmount}
                propData={updatedData}
                contractId={contract_id}
              />
            ) : (
              ""
            )}
            {cancelPopUp ? (
              <CancelPopUpInvoice
                cancelPopUp={cancelPopUp}
                setCancelPopUp={setCancelPopUp}
                propData={updatedData}
                contractId={contract_id}
              />
            ) : (
              ""
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "30px",
            }}
            // className="p-1 bg-red text-white rounded-md max-w-sm m-3 my-2 flex gap-1 ml-30 justify-center items-center"
          >
            <button
              style={{
                padding: "8px 20px",
                fontSize: "16px",
                backgroundColor: "black",
                color: "white",
                border: "none",
                marginRight: "20px",
                borderRadius: "5px",
              }}
              disabled={parseInt(invoiceNumber.credit_note) > 0}
              onClick={() => {
                onCancelInvoiceClick();
              }}
            >
              CANCEL INVOICE
            </button>
            <button
              style={{
                padding: "8px 20px",
                fontSize: "16px",
                backgroundColor: "black",
                color: "white",
                border: "none",
                marginRight: "20px",
                borderRadius: "5px",
              }}
              onClick={() => {
                deleteEmployee();
              }}
              disabled={
                selectedCandidates?.length <= 0 ||
                parseInt(invoiceNumber.credit_note) > 0
              }
            >
              REMOVE
            </button>
            <button
              style={{
                padding: "8px 20px",
                fontSize: "16px",
                backgroundColor: "red",
                color: "white",
                border: "none",
                borderRadius: "5px",
              }}
              disabled={
                selectedCandidates?.length > 0 ||
                (updatedData && updatedData[0]?.amount_received != null)
              }
              onClick={() => {
                onSubmit();
              }}
            >
              SUBMIT
            </button>
          </div>
        </>
      )}
    </>
  );
}
